<template>
  <div class="id-code-page">
    <van-nav-bar title="我的识别码" left-text="返回" left-arrow @click-left="$router.go(-1)" />

    <div class="code-container">
      <van-loading v-if="loading" size="24px">加载中...</van-loading>
      <div v-else class="code-value">{{ idCode }}</div>
      <div class="code-hint">展示专属识别码</div>
    </div>
  </div>
</template>

<script>
import { showToast } from 'vant';
import userApi from '@/api/user'

export default {
  name: 'MyIdCode',
  data() {
    return {
      idCode: '',
      loading: false
    }
  },
  created() {
    this.fetchIdCode()
  },
  methods: {
    async fetchIdCode() {
      this.loading = true
      try {
        const response = await userApi.GetMyIdCode()
        if (response && response.value) {
          this.idCode = response.value
        }
      } catch (error) {
        console.error('获取识别码失败:', error)
        showToast('获取识别码失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.id-code-page {
  height: 100vh;
  background-color: #f7f8fa;
}

.code-container {
  margin: 40px auto;
  text-align: center;
}

.code-value {
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 5px;
  color: #1989fa;
  margin-bottom: 16px;
}

.code-hint {
  font-size: 14px;
  color: #969799;
}
</style>